import { MainComponent } from './core/layouts/main/main.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './core/login/login.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'homepage',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      pageTitle: 'pageTitle_login'
    }
  },
  {
    path: '',
    component: MainComponent,
    data: {
      title: 'home',
      keyPage: 'home'
    },
    children: [
      {
        path: 'homepage',
        loadChildren: () => import('./views/homepage/homepage.module').then(m => m.HomepageModule)
      },
      {
        path: 'qlik-mashup/:appId/:sheetId/:pageTitle',
        loadChildren: () => import('./views/qlik-mashup/qlik-mashup.module').then(m => m.QlikMashupModule)
      },
      {
        path: 'richiesta-assistenza',
        loadChildren: () => import('./views/richiesta-assistenza/richiesta-assistenza.module').then(m => m.RichiestaAssistenzaModule)
      },
      {
        path: 'simulativo',
        loadChildren: () => import('./views/simulativo/simulativo.module').then(m => m.SimulativoModule)
      },
      {
        path: 'simulativo/dashboard',
        loadChildren: () => import('./views/simulativo/dashboard-simulativo/dashboard-simulativo.module').then(m => m.DashboardSimulativoModule)
      },
      {
        path: 'simulativo/simulazione/nuova',
        loadChildren: () => import('./views/simulativo/simulazione/simulazione.module').then(m => m.SimulazioneModule)
      },
      {
        path: 'simulativo/simulazione/modifica/:id',
        loadChildren: () => import('./views/simulativo/simulazione/simulazione.module').then(m => m.SimulazioneModule)
      },
      {
        path: 'simulativo/simulazione/duplica/:id',
        loadChildren: () => import('./views/simulativo/simulazione/simulazione.module').then(m => m.SimulazioneModule)
      },
      {
        path: 'simulativo/simulazione/dettaglio/:id',
        loadChildren: () => import('./views/simulativo/dettaglio-simulazione/dettaglio-simulazione.module').then(m => m.DettaglioSimulazioneModule)
      },
      {
        path: 'simulativo/simulazione/confronto',
        loadChildren: () => import('./views/simulativo/confronta-simulazioni/confronta-simulazioni.module').then(m => m.ConfrontaSimulazioniModule)
      },
      {
        path: 'pricing-derivati-cambi',
        loadChildren: () => import('./views/pricing-derivati-cambi/pricing-derivati-cambi.module').then(m => m.PricingDerivatiCambiModule)
      },
      {
        path: 'pricing-derivati-cambi/nuovo',
        loadChildren: () => import('./views/pricing-derivati-cambi/insert-edit-pricing/insert-edit-pricing.module').then(m => m.InsertEditPricingModule)
      },
      {
        path: 'pricing-derivati-cambi/modifica',
        loadChildren: () => import('./views/pricing-derivati-cambi/insert-edit-pricing/insert-edit-pricing.module').then(m => m.InsertEditPricingModule)
      },
      {
        path: 'pricing-derivati-cambi/duplica',
        loadChildren: () => import('./views/pricing-derivati-cambi/insert-edit-pricing/insert-edit-pricing.module').then(m => m.InsertEditPricingModule)
      },
      {
        path: 'gestione-utenti',
        loadChildren: () => import('./views/admin/gestione-utenti/gestione-utenti.module').then(m => m.GestioneUtentiModule)
      },
      {
        path: 'gestione-utenti/nuovo',
        loadChildren: () => import('./views/admin/gestione-utenti/insert-edit-utente/insert-edit-utente.module').then(m => m.InsertEditUtenteModule)
      },
      {
        path: 'gestione-utenti/modifica/:userid',
        loadChildren: () => import('./views/admin/gestione-utenti/insert-edit-utente/insert-edit-utente.module').then(m => m.InsertEditUtenteModule)
      },
      {
        path: 'gestione-gruppi',
        loadChildren: () => import('./views/admin/gestione-gruppi/gestione-gruppi.module').then(m => m.GestioneGruppiModule)
      },
      {
        path: 'gestione-gruppi/nuovo',
        loadChildren: () => import('./views/admin/gestione-gruppi/insert-edit-gruppo/insert-edit-gruppo.module').then(m => m.InsertEditGruppoModule)
      },
      {
        path: 'gestione-gruppi/modifica/:gruppo',
        loadChildren: () => import('./views/admin/gestione-gruppi/insert-edit-gruppo/insert-edit-gruppo.module').then(m => m.InsertEditGruppoModule)
      },
      {
        path: 'upload-modelli',
        loadChildren: () => import('./views/admin/upload-modelli/upload-modelli.module').then(m => m.UploadModelliModule)
      },
      {
        path: 'marketplace',
        loadChildren: () => import('./views/marketplace/marketplace.module').then(m => m.MarketplaceModule)
      },
      {
        path: 'tutorial',
        loadChildren: () => import('./views/tutorial/tutorial.module').then(m => m.TutorialModule)
      },
      {
        path: 'dettaglio-utente',
        loadChildren: () => import('./views/dettaglio-utente/dettaglio-utente.module').then(m => m.DettaglioUtenteModule)
      },
      {
        path: 'cambio-obiettivo',
        loadChildren: () => import('./views/modello-cambio-obiettivo/modello-cambio-obiettivo.module').then(m => m.ModelloCambioObiettivoModule)
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
